module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/twitter-f7bb5bf512cea46241b7c3618c4d94ae.png";